import { render } from "./LeaveFormView.vue?vue&type=template&id=50272fa4&scoped=true"
import script from "./LeaveFormView.vue?vue&type=script&lang=js"
export * from "./LeaveFormView.vue?vue&type=script&lang=js"

import "./LeaveFormView.vue?vue&type=style&index=0&id=50272fa4&scoped=true&lang=css"

import exportComponent from "/home/timecard-test/OggiTimeClockSystem/electron/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50272fa4"]])

export default __exports__